/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 申込者情報
 */
export interface Sgkb575aResSrnperInfo {
    /** 
     * お申し出者種別コード：半角英数混在
     */
    applicantClscode?: string;
    /** 
     * お申し出者種別コード名称：全角半角混在
     */
    applicantClsfyCodeaname?: string;
    /** 
     * 申込者漢字氏名：全角文字
     */
    srnperName?: string;
    /** 
     * 申込者カナ氏名：全角カナ
     */
    srnperKanaName?: string;
    /** 
     * 申込者電話番号コード：半角英数混在
     */
    srnperTeldv?: string;
    /** 
     * 申込者電話番号コード名称：全角半角混在
     */
    srnperTeldvAname?: string;
    /** 
     * 申込者電話番号：電話番号(ハイフンと数値含む)
     */
    srnperTelNo?: string;
}
